import { KLineData } from 'klinecharts';
import { PriceBarDto } from '../shell-communication/dtos/price-bar-dto.interface';

export interface NormalizationStats {
   rawCount: number;
   duplicateTsCount: number;
   zeroRangeBarCount: number;
   zeroRangeBarDropped: number;
   monotonicAscending: boolean;
}

export function toKLineData(dto: PriceBarDto): KLineData {
   return {
      timestamp: dto.date.getTime(),
      open: dto.open,
      high: dto.high,
      low: dto.low,
      close: dto.close,
      volume: dto.volume
   };
}

export function normalizeKLineData(input: KLineData[]): { bars: KLineData[]; stats: NormalizationStats } {
   const rawCount = input.length;
   let monotonicAscending = true;
   let prevTs = -Infinity;
   let zeroRangeBarCount = 0;

   const byTs = new Map<number, KLineData>();
   for (const bar of input) {
      if (bar.timestamp < prevTs) {
         monotonicAscending = false;
      }
      prevTs = bar.timestamp;

      if (bar.high === bar.low) {
         zeroRangeBarCount++;
      }

      byTs.set(bar.timestamp, bar);
   }

   const bars = Array.from(byTs.values()).sort((a, b) => a.timestamp - b.timestamp);
   const duplicateTsCount = rawCount - bars.length;

   return {
      bars,
      stats: { rawCount, duplicateTsCount, zeroRangeBarCount, zeroRangeBarDropped: 0, monotonicAscending }
   };
}
